<template>
   <div id="sets--view">
    <v-toolbar color="transparent" dense flat>
      <v-toolbar-title>{{$t('view_settings_header')}}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>

    <div class="pa-3">
      <div style="text-align:left; max-width:100%; width:100vh" >
        <span class="subheading"> {{$t('chat_messages_header')}}</span>
        <v-slider
          width="100%"
          :label="$t('chat_messages_header_size')"
          v-model="fontSize"
          min="12"
          max="20"
          step="1"
          thumb-label
          v-on:mouseup = "fontSizeChanged"
        ></v-slider> 
      </div>
    </div>
    <v-divider></v-divider>

    <div class="pa-3">
      <div style="text-align:left; max-width:100%; width:100vh" >
        <span class="subheading"> {{$t('chat_settings_header')}}</span>
        <v-layout justify-space-between row>
          <v-layout justify-space-around column fill-height style="max-width:calc(100% - 100px)">
            {{$t('chat_background_header')}}
            <span class="caption text-truncate">{{backgroundImage?backgroundImage:"None"}}</span>
          </v-layout>
          <v-layout justify-end row style="width:100px">
            <v-btn fab dark small color="green" @click="uploadBackground" >
              <v-icon dark>cloud_upload</v-icon>
            </v-btn>
            <v-btn fab dark small color="red" class="ml-0" @click="removeBackground" :disabled="!backgroundImage"> 
              <v-icon dark>delete</v-icon>
            </v-btn> 
          </v-layout>
        </v-layout>
      </div>
    </div>
    <v-divider></v-divider>
    
    <div class="pa-3">
      {{$t('theme_title')}}
      <v-switch
        :label="$t('theme_dark')"
        v-model="isDark"
        v-on:change="themeChanged"
      ></v-switch>
    </div>
  </div> 
</template>

<script>
import fileSelector from '@utils/fileSelector'
import { EventBus } from '@/event-bus'

export default {
  components: { 

  },
  props: {
        
  },
  data () {
    return {
      backgroundImage: "",
      fontSize: 14,
      isDark: false
    }
  },
  mounted() {
    this.$store.dispatch('readSettings').then(sets => {
      this.backgroundImage = sets.background
      this.fontSize = sets.fontSize
      this.isDark = sets.theme
    })
  },
  methods: {
      uploadBackground() {       
        const file = fileSelector.openBackground(this)
        if (file.length < 1)
          return
        this.$store.dispatch('uploadChatBackground', file[0]).then((fileCopy) => {
          this.backgroundImage = fileCopy
          EventBus.$emit('chat-background-changed')
        })
      },
      removeBackground() {
        this.$store.dispatch('removeChatBackground').then(() => {
          this.backgroundImage = ''
          EventBus.$emit('chat-background-changed')
        })
      },
      fontSizeChanged() {
        this.$store.dispatch('updateFontSize', this.fontSize)
      },
      themeChanged() {
        this.$store.dispatch('setTheme', this.isDark)
      }
    },
}
</script>

